import { render, staticRenderFns } from "./AssignCoachEditTabSocial.vue?vue&type=template&id=64c6517e&"
import script from "./AssignCoachEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./AssignCoachEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports